import { FC, HTMLAttributes } from "react";
import { useStyles } from "./StatCard.style";
import { Skeleton } from "../../core/Skeleton";

export const StatCardLoading: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.statContent}>
        <Skeleton variant="text" width={200} height={30} />
        <Skeleton variant="text" width={80} height={40} />
      </div>
    </div>
  );
};
